import React from 'react';

interface State { hasError: boolean; error: Error | null; componentStack: string | null; }

export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false, error: null, componentStack: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, componentStack: null };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ componentStack: info.componentStack ?? null });
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f5f2', padding: 24 }}>
          <div style={{ background: '#fff', borderRadius: 4, padding: 32, maxWidth: 680, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', border: '1px solid rgba(0,0,0,0.1)' }}>
            <div style={{ width: 48, height: 48, borderRadius: 4, background: '#FEF2F2', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
              <span style={{ fontSize: 24 }}>⚠️</span>
            </div>
            <h2 style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 700, fontSize: 20, color: '#1a1a2e', margin: '0 0 8px' }}>Something went wrong</h2>
            <p style={{ fontSize: 14, color: '#5a5a6e', margin: '0 0 16px' }}>The application encountered an unexpected error. Please refresh the page.</p>
            <pre style={{ fontSize: 11, color: '#DC2626', background: '#FEF2F2', borderRadius: 8, padding: '10px 14px', overflow: 'auto', maxHeight: 160, margin: '0 0 12px' }}>
              {this.state.error?.message}
              {'\n\n'}
              {this.state.error?.stack?.split('\n').slice(0, 6).join('\n')}
            </pre>
            {this.state.componentStack && (
              <pre style={{ fontSize: 10, color: '#7C3AED', background: '#F5F3FF', borderRadius: 8, padding: '10px 14px', overflow: 'auto', maxHeight: 200, margin: '0 0 16px', whiteSpace: 'pre-wrap' }}>
                {'Component stack:'}
                {this.state.componentStack.split('\n').slice(0, 12).join('\n')}
              </pre>
            )}
            <button onClick={() => window.location.reload()} style={{ padding: '8px 20px', borderRadius: 8, background: '#b07d1a', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
              Refresh Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
